import { connector } from "../../utils/common/connector";

const controller = "campaignCustomer";

// ---------------------------------------------
// CREATE CAMPAIGN CUSTOMER
// ---------------------------------------------
export const createCampaignCustomerService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.post(
      controller,
      "createCampaignCustomer",
      params,
    );

    reply = {
      campaignCustomer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignCustomer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CAMPAIGN CUSTOMER BY ID
// ---------------------------------------------
export const getCampaignCustomerByIdService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(controller, "byId", params);

    reply = {
      campaignCustomer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignCustomer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// GET CUSTOMERS BY CAMPAIGN LIST ID
// ---------------------------------------------
export const getCampaignCustomersByCampaignListIdService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.get(
      controller,
      "getCampaignCustomersByCampaignListId",
      params,
    );

    reply = {
      customers: response?.customers ?? [],
      totalCustomers: response?.totalRecords ?? 0,
    };
  } catch (error) {
    console.log(error);
    reply = {
      customers: [],
      totalCustomers: 0,
    };
  }

  return reply;
};

// ---------------------------------------------
// DELETE CAMPAIGN CUSTOMER
// ---------------------------------------------
export const deleteCampaignCustomerByIdService = async (params) => {
  let reply = { ok: false };

  try {
    const response = await connector.post(
      controller,
      "deleteCampaignCustomerById",
      params,
    );

    reply = {
      campaignCustomer: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignCustomer: {},
    };
  }

  return reply;
};

// ---------------------------------------------
// DELETE ALL CAMPAIGN CUSTOMERS
// ---------------------------------------------
export const deleteCampaignCustomersByCampaignListIdService = async (
  params,
) => {
  let reply = { ok: false };

  try {
    const response = await connector.post(
      controller,
      "deleteCampaignCustomersByCampaignListId",
      params,
    );

    reply = {
      campaignCustomers: response ?? {},
    };
  } catch (error) {
    console.log(error);
    reply = {
      campaignCustomers: {},
    };
  }

  return reply;
};
